import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { HostControlDirective, InputAutocomplete, InputError } from '@ebeihilfe/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'portal-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [TranslateModule, ReactiveFormsModule, MatFormField, MatFormFieldModule, MatInput],
  hostDirectives: [HostControlDirective],
})
export class TextInputComponent {
  public accessorDirective = inject(HostControlDirective);
  public autocomplete = input<InputAutocomplete>('off');
  public errors = input<InputError[]>([]);
  public hideRequiredMarker = input(true);
  public hint = input('');
  public label = input('');
  public placeholder = input('');
  public type = input<'text' | 'email'>('text');
}
